import {Injectable} from '@angular/core';
import {Categoria} from '../models/categoria';
import {Macchina} from '../models/macchina';
import {Garanzia} from '../models/garanzia';
import {Evento} from '../models/evento';
import {Carrello} from '../models/carrello';
import {Ordine} from '../models/ordine';
import {Matricola} from '../models/matricola';
import {Accessorio} from '../models/accessorio';
import {TipoAccessorio} from '../models/tipoaccessorio';
import {AppSettings} from '../models/AppSettings';
import {URLSearchParams} from "@angular/http";
import {Router} from '@angular/router';
import {UserService} from './user.service';
import {Ricambio} from '../models/ricambio';

import {Headers} from '@angular/http';

import {Http} from '@angular/http';
//import { HttpService } from './httpcliente.service';
 import 'rxjs/Rx' ;
import 'rxjs/add/operator/toPromise';
@Injectable()

export class RicambiService {
    private categorieUrl = 'categoriaMacchina';  // URL to web api
    private macchinaUrl = 'macchina';  // URL to web api
    private carrelloUrl = 'carrello/';  // URL to web api
    private garanziaUrl = 'garanzia';
    private matricoleUrl = 'matricole';
    private accessorioUrl = 'accessorio';
    private ricambiUrl = 'ricambi';
    private urlTipoDocumentazione = 'areadoc';
    private urlDocumentazione = 'documentazione';
    private urlDocumentazionDownload="documentazioneDownload";
    private urlEventi="eventi";

    private categorie: Categoria[] = undefined;
    private headers = new Headers({'Content-Type': 'application/json'});
    constructor(private user: UserService, private http: Http, private router: Router) {

    }

    resetCategorie(): void {
        this.categorie = undefined;
        this.getCategorie();
    }

    getCategorie(): Promise<any> {
        if (this.categorie) {
            return Promise.resolve(this.categorie);
        } else {
            return this.http.get(AppSettings.API_ENDPOINT + this.categorieUrl)
                .toPromise()
                .then(
                response => {
                    let v = response.json() as Categoria[]
                    this.categorie = v;
                    return v;
                }
                )
                .catch(res => {this.handleError(res);});
        }
    }

    private handleResult(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error); //temporaneo
        /*if (error.type == 3 || error.status==403) {//403?!?!
           this.user.nonAutorizzato();
        } else {
            return Promise.reject(error.message || error);
        } */
    }
    getMacchine(cat: Categoria): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.categorieUrl + "/" + cat.id)
            .toPromise()
            .then(
            response => response.json() as Macchina[]
            ).catch(res => {this.handleError(res);});
    }
    getMacchina(id: any): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.macchinaUrl + "/" + id)
            .toPromise()
            .then(
            response => response.json() as Macchina
            ).catch(res => {this.handleError(res);});
    }
    aggiungiCarrello(id: any, qta: number): Promise<any> {
        let data = new URLSearchParams();
        data.append('articolo', id);
        data.append('qta', "" + qta);
        data.append('azione', "aggiungi");
        return this.http.post(AppSettings.API_ENDPOINT + this.carrelloUrl, data)
            .toPromise()
            .then(
            response => response.json() as Carrello
            ).catch(res => {this.handleError(res);});
    }

    getCarrello(): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.carrelloUrl)
            .toPromise()
            .then(
            response => response.json() as Ordine
            ).catch(res => {this.handleError(res);});
    }
    
    importaOrdine(ordine:Ordine,carrello:string): Promise<any>{
        let data = new URLSearchParams();
        data.append('azione', "importa");
        data.append('idOrdine',carrello);

        return this.http
            .post(AppSettings.API_ENDPOINT + this.carrelloUrl, data).toPromise()
            .then(res => res.json() as Ordine)
            .catch(res => {this.handleError(res);});
    }

    aggiornaOrdine(ordine: Ordine, azione: string): Promise<any> {
        let data = new URLSearchParams();
        if (ordine) {
            let lista: Array<any> = new Array();
            data.append('testo', ordine.note);
            for (let x in ordine.righe) {
                let i: Carrello = ordine.righe[x];
                lista.push({"id": i.id, "qta": i.qta});
            }
            data.append('righe', JSON.stringify(lista));
        }
        data.append('azione', azione);

        return this.http
            .post(AppSettings.API_ENDPOINT + this.carrelloUrl, data).toPromise()
            .then(res => res.json() as Ordine)
            .catch(res => {this.handleError(res);});
    }

    salvaOrdine(ordine: Ordine): Promise<any> {
        return this.aggiornaOrdine(ordine, "salva");
    }


    confermaOrdine(ordine: Ordine): Promise<any> {
        return this.aggiornaOrdine(ordine, "conferma");
    }
    eliminaOrdine(): Promise<any> {
        return this.aggiornaOrdine(undefined, "svuota");
    }
    rimuoviCarrello(id: number): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.carrelloUrl + "?azione=elimina&riga=" + id)
            .toPromise()
            .then(
            response => response.json() as Ordine
            ).catch(res => {this.handleError(res);});
    }
    cercaMacchine(codice: string, descrizione: string, matricola: string): Promise<any> {
        let data = new URLSearchParams();
        data.append('codice', codice);
        data.append('descrizione', descrizione);
        data.append('matricola', matricola);
        data.append('azione', "ricerca");

        return this.http
            .post(AppSettings.API_ENDPOINT + this.macchinaUrl, data).toPromise()
            .then(res => res.json() as Macchina[])
            .catch(res => {this.handleError(res);});
    }

    inviaDatiGaranzia(id: number, garanzia: Garanzia): Promise<any> {
        let input = new URLSearchParams();
        //let input = new FormData();
        input.append("id", "" + id);
        input.append("dati", JSON.stringify(garanzia));//la mando tutta
        return this.http.post(AppSettings.API_ENDPOINT + this.garanziaUrl, input).toPromise()
            .then(res => res.json())
            .catch(res => {this.handleError(res);});
    }
    inviaFileGaranzia(id: any, file: any): Promise<any> {
        let input = new FormData();
        input.append("file", file);
        input.append("id", id);
        return this.http.post(AppSettings.API_ENDPOINT + this.garanziaUrl, input).toPromise().then(res => res.json())
            .catch(res => {this.handleError(res);});;
    }


    public static traduci(role: string): string {
        //return role + " TRAD ";
        let trad = AppSettings.listaTraduzioni;
        if (trad[role]) {
            return trad[role];
        } else {
            AppSettings.aggiungiNuovaTraduzione(role);
        }
        return role;
    }

    cercaAccessori(codice: string, descrizione: string, tipo: number, categoria: number): Promise<any> {
        let data = new URLSearchParams();
        data.append('codice', codice);
        data.append('descrizione', descrizione);
        data.append('categoria', "" + categoria);
        data.append('tipo', "" + tipo);
        data.append('azione', "ricerca");

        return this.http
            .post(AppSettings.API_ENDPOINT + this.accessorioUrl, data).toPromise()
            .then(res => res.json() as Accessorio[])
            .catch(res => {this.handleError(res);});
    }
    
    getCategorieRicambi(): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.ricambiUrl)
            .toPromise()
            .then(
            response => response.json()
            ).catch(res => {this.handleError(res);});
    }
    getRicambi(categoria: number): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.ricambiUrl + "/" + categoria)
            .toPromise()
            .then(
            response => response.json() as Ricambio[]
            ).catch(res => {this.handleError(res);});
    }

    cercaRicambi(codice: string, descrizione: string): Promise<any> {
        let data = new URLSearchParams();
        data.append('codice', codice);
        data.append('descrizione', descrizione);

        return this.http
            .post(AppSettings.API_ENDPOINT + this.ricambiUrl, data).toPromise()
            .then(res => res.json() as Ricambio[])
            .catch(res => {this.handleError(res);});
    }

    getTipoAccessori(cat: Categoria): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.accessorioUrl + "/" + cat.id + "?azione=categorieAccessori")
            .toPromise()
            .then(
            response => response.json() as TipoAccessorio[]
            ).catch(res => {this.handleError(res);});
    }

    getAccessorio(id: any): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.accessorioUrl + "/" + id)
            .toPromise()
            .then(
            response => response.json() as Accessorio
            ).catch(res => {this.handleError(res);});
    }
    cercaCompatibilita(cat: Categoria, tipo: number): Promise<any[]> {
        return this.http.get(AppSettings.API_ENDPOINT + this.accessorioUrl + "/" + cat.id + "?azione=compatibilita&tipoAccessorio=" + tipo)
            .toPromise()
            .then(
            response => response.json()
            ).catch(res => {this.handleError(res);});
    }

    getMatricole(): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.matricoleUrl + "/")
            .toPromise()
            .then(
            response => response.json() as Matricola[]
            )
            .catch(res => {this.handleError(res);});
    }
    
     getEventi(): Promise<any> {
         return this.http.get(AppSettings.API_ENDPOINT + this.urlEventi + "/")
            .toPromise()
            .then(
            response => response.json() as Evento[]
            )
            .catch(res => {this.handleError(res);});
    }
    
    cercaMatricole(codice: string, descrizione: string, matricola: string): Promise<any> {
        let data = new URLSearchParams();
        data.append('codice', codice);
        data.append('descrizione', descrizione);
        data.append('matricola', matricola);
        data.append('azione', "ricerca");

        return this.http
            .post(AppSettings.API_ENDPOINT + this.matricoleUrl, data).toPromise()
            .then(res => res.json() as Matricola[])
            .catch(res => {this.handleError(res);});
    }
    getMatricola(id: any): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.matricoleUrl + "/" + id + "?par=id")
            .toPromise()
            .then(
            response => response.json() as Matricola
            )
            .catch(res => {this.handleError(res);});
    }
    getAreaDocumentazione(): Promise<any[]> {
        return this.http.get(AppSettings.API_ENDPOINT + this.urlTipoDocumentazione)
            .toPromise()
            .then(
            response => response.json()
            ).catch(res => {this.handleError(res);});
    }

    cercaDocumentazione(idArea, testo): Promise<any[]> {
        let data = new URLSearchParams();
        data.append('area', idArea);
        data.append('search', testo);
        return this.http
            .post(AppSettings.API_ENDPOINT + this.urlDocumentazione, data).toPromise()
            .then(res => res.json())
            .catch(res => {this.handleError(res);});
    }

    urlDownloadDocumentazione(files:Array<number>):string{
        let dati=new Object();
        dati["files"]=files;
        dati["auth"] = this.user.getProfilo().sessionUID;
        dati["uid"] = this.user.getProfilo().uid;
        
        return AppSettings.API_ENDPOINT + this.urlDocumentazionDownload+"?data="+btoa(JSON.stringify(dati));
    }

   
    
    creaWebSocketCarrello() {

    }

}



// WEBPACK FOOTER //
// ./src/app/service/ricambi.service.ts